export { default as FreeRadio } from './FreeRadio.vue';
